(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["filter-category"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.cat-pills__item');
    if (!link) return;

    const facetsForm = document.querySelector('facets-form-component');
    if (!facetsForm || typeof facetsForm.updateFiltersByURL !== 'function') return;

    event.preventDefault();
    facetsForm.updateFiltersByURL(link.href);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-category"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-tab-trigger]');
    if (!trigger) return;

    const wrapper = trigger.closest('.shop-by-category');
    if (!wrapper) return;

    const targetId = trigger.dataset.tabTrigger;

    wrapper.querySelectorAll('[data-tab-trigger]').forEach((btn) => {
      const isActive = btn.dataset.tabTrigger === targetId;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-selected', isActive);
    });

    wrapper.querySelectorAll('[data-tab-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.tabPanel !== targetId;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
